import React from 'react'
import { Box, styled } from '@mui/material'

export interface IStateIconProps {
  iconlabel: string
  iconweight?: string
  iconcolor: string | null
  iconsize?: string
}

const StyledStateIcon = styled(Box)(({ iconcolor, iconsize }: IStateIconProps) => {
  return `
    position: relative;
    display:flex;
    justify-content: center;
    align-items: center;
    color: ${iconcolor};
    font-size: ${iconsize ? iconsize : '16px'};
    width: 24px;
    height: 24px;
  `
})

const StateIcon = ({
  iconlabel,
  iconweight,
  iconcolor,
  iconsize,
  ...props
}: IStateIconProps) => {
  return (
    <StyledStateIcon iconlabel={iconlabel} iconcolor={iconcolor} iconsize={iconsize} {...props}>
      <i
        className={`fa-${iconweight ? iconweight : 'solid'} fa-${iconlabel}`}
      />
    </StyledStateIcon>
  )
}

export default StateIcon
